<template>
  <div id="app">
    <navbar v-if="showNavbar() === true" />
    <div style="height: 100vh;">
      <router-view></router-view>
    </div>
    <Modals />
    <ModalInfo
      :openModal.sync="dataModalInfo.show"
      :dataModal="dataModalInfo"
    />
  </div>
</template>

<script>
import axios from 'axios'
import navbar from './components/global/Navbar.vue'
import Modals from './components/global/modals/Main.vue'
import ModalInfo from './components/global/modals/ModalInfo.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css'
// import { router } from '@/router'

export default {
  name: 'App',
  components: {
    navbar,
    Modals,
    ModalInfo
  },
  data() {
    return {
      dataModalInfo: {
        show: false,
        text: '',
        img: require('@/assets/image/icon/failed.svg'),
        typeModal: 'INFO', // CONFIRM (button yes & no), INFO (button ok)
        buttons: null
      }
    }
  },
  created: function() {
    const el = this
    axios.interceptors.response.use(
      response => {
        // intercept the global error
        let token = localStorage.getItem('token')
        if (token) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
        }

        return response
      },
      function(error) {
        let originalRequest = error.config
        if (error.response.status === 401 && !originalRequest._retry) {
          // if the error is 401 and hasent already been retried
          originalRequest._retry = true // now it can be retried
          el.errorAxios()
          // let token = localStorage.getItem('token')
          // router.push('/signin')
        }
        if (error.response.status === 404 && !originalRequest._retry) {
          originalRequest._retry = true
          // window.location.href = '/'
          el.dataModalInfo.text = `${error.response.status} - Internal Server Error!`
          el.dataModalInfo.show = true
          return
        }
        // Do something with response error
        return Promise.reject(error)
      }
    )
  },
  methods: {
    showNavbar() {
      const token = localStorage.getItem('token')
      if (
        this.$route.name === 'Signin' ||
        this.$route.name === 'RegisterCustomer'
      ) {
        return false
      }
      if (this.$route.name === 'Landingpage' && !token) {
        return false
      }
      return true
    },
    errorAxios() {
      localStorage.clear()
      localStorage.setItem('history', this.$router.history._startLocation)
      this.$router.push('/signin').then(() => {})
    }
  }
}
</script>

<style lang="scss">
@import '~styles';
</style>



// WEBPACK FOOTER //
// src/App.vue